/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Embed_Registration_DescriptionInputs */

const en_admin_embed_registration_description = /** @type {(inputs: Admin_Embed_Registration_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Embed the Matching Week widget so participants can register for Matching Week directly on your website.`)
};

const de_admin_embed_registration_description = /** @type {(inputs: Admin_Embed_Registration_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Betten Sie das Matching-Week-Widget ein, damit Teilnehmende sich direkt auf Ihrer Webseite für die Matching Week registrieren können.`)
};

/**
* | output |
* | --- |
* | "Embed the Matching Week widget so participants can register for Matching Week directly on your website." |
*
* @param {Admin_Embed_Registration_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_embed_registration_description = /** @type {((inputs?: Admin_Embed_Registration_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Embed_Registration_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_embed_registration_description(inputs)
	return en_admin_embed_registration_description(inputs)
});